import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../../../reducer/CombineReducer";
import {
  Button,
  Checkbox,
  Input
} from "../../../../Common/UI/Index";
import { ButtonVariantType } from "../../../../Common/UI/Types";
import Search from "~icons/ic/outline-search";
import Add from "~icons/ic/baseline-add-circle";

interface Props {
  /**
   * Action for add new config
   */
  onAddNewConfig: () => void;
  /**
   * Action on Show Bandings Change
   */
  onShowBandingsToggle: (value: boolean) => void;
  /**
   * Action for Search by tag name
   */
  onSearchByTag: (value: string) => void;
}

/**
 * Responsible to render output mapping buttons bar
 * @returns output mapping buttons bar view
 */
export const OutputMappingButtonsBarView: React.FC<Props> = (props: Props) => {
  const {
    onAddNewConfig,
    onShowBandingsToggle,
    onSearchByTag
  } = props;
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const { mappingFilters, searchByTagName } = outputConfig;
  const { showBandings } = mappingFilters;

  /**
   * To make the show bandings checked
   */
  useEffect(() => {
    onShowBandingsToggle(true);
  }, []);

  /**
   * Action on search value change, move to tag
   */
  const onSearchByTagChange = (e: React.SyntheticEvent<HTMLInputElement>): void => {
    onSearchByTag(e.currentTarget.value);
  };

  /**
   * Action on show bandings checknox logic
   */
  const onShowBandingsChange = (isChecked: boolean): void => {
    onShowBandingsToggle(isChecked);
  };

  /**
   * Method for clear icon
   */
  const onClearBandingsTag = (): void => {
    onSearchByTag("");
  };

  return (
    <div className="output-config__switcher">
      <div
        className="output-config__showbandings"
        id="ebt-outputConfig-config-leftPane"
      >
        <div className="output-config__searchBoxTag">
          <Input
            ariaLabel="with-icon"
            placeholder="Search tag name"
            value={searchByTagName}
            onChange={onSearchByTagChange}
            clearable={true}
            onClear={onClearBandingsTag}
            id="ebt-outputConfig-config-searchBand"
          >
            <Search title="search" />
          </Input>
        </div>
        <div>
          <Checkbox
            labelText={translate("OutputConfig.OutputMapping.ShowBandings")}
            checked={showBandings}
            onChange={onShowBandingsChange}
            id="ebt-outputConfig-config-showBandings"
          />
        </div>
      </div>
      <Button
        variant={ButtonVariantType.FILLED}
        onClick={onAddNewConfig}
        id="ebt-outputConfig-config-addConfig">
        <Add title="Add" />
        {translate("OutputConfig.OutputMappingButtons.AddNewConfig")}
      </Button>
    </div>
  );
};
